import React, { useEffect, useRef, useState } from 'react'
import { EMAIL_REGEX, ENDPOINT_ACCOUNT_UPDATE } from '../Config';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const Account = () => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const emailRef = useRef();
  const [errMsg, setErrMsg] = useState('');
  const [successMessage, setSuccessMessage] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [email, setEmail] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);

  useEffect(() => {
    if (auth.account.Role === 'SUPER_ADMIN') {
      navigate("/", { replace: true });
      return;
    }
    setFirstName(auth.account.FirstName);
    setLastName(auth.account.LastName);
    setEmail(auth.account.EmailAddress);
  }, [])
  useEffect(() => {
    setErrMsg('');
    setValidEmail(EMAIL_REGEX.test(email));
  }, [email])

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!EMAIL_REGEX.test(email)) {
      setErrMsg("Invalid Entry");
      return;
    }
    try {
      setSubmitting(true);
      const response = await axiosPrivate.put(ENDPOINT_ACCOUNT_UPDATE,
        JSON.stringify({
          fname: firstName,
          lname: lastName,
          email: email
        }));
      if (response.status == 200) {
        setAuth((prev) => ({
          ...prev,
          account: {
            ...prev.account,
            FirstName: firstName,
            LastName: lastName,
            EmailAddress: email,
          }
        }));
        setSuccessMessage("Your account updated successfully!");
        setTimeout(() => setSuccessMessage(null), 5000);
      }
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 409) {
        setErrMsg('Username Taken');
      } else {
        setErrMsg(err?.response?.data.data ?? 'Registration Failed')
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-md-4">
        <h2 className="mb-3">
          My Account
        </h2>
        <p className={successMessage ? "alert alert-success" : "offscreen"} aria-live="assertive">{successMessage}</p>
        <p className={errMsg ? "alert alert-danger" : "offscreen"} aria-live="assertive">{errMsg}</p>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <div className="row">
              <div className="col">
                <label htmlFor="firstName">
                  First Name:
                </label>
                <input
                  className={`form-control ${!firstName.trim().length ? "is-invalid" : ""}`}
                  type="text"
                  id="firstName"
                  onChange={(e) => setFirstName(e.target.value)}
                  value={firstName}
                  required
                  style={{ textTransform: "capitalize" }}
                />
              </div>
              <div className="col">
                <label htmlFor="lastName">
                  Last Name:
                </label>
                <input
                  className={`form-control ${!lastName.trim().length ? "is-invalid" : ""}`}
                  type="text"
                  id="lastName"
                  onChange={(e) => setLastName(e.target.value)}
                  value={lastName}
                  required
                  style={{ textTransform: "capitalize" }}
                />
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="email">
              Email:
            </label>
            <input
              className={`form-control ${!validEmail ? "is-invalid" : ""}`}
              type="text"
              id="email"
              ref={emailRef}
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              required
              aria-invalid={validEmail ? "false" : "true"}
              aria-describedby="uidnote"
              onFocus={() => setEmailFocus(true)}
              onBlur={() => setEmailFocus(false)}
            />
            <div id="uidnote" className={emailFocus && email && !validEmail ? "invalid-feedback" : "d-none"}>
              Invalid email address
            </div>
          </div>
          <div className="text-center">
            <button className="btn btn-primary" disabled={!validEmail || submitting}>
              {submitting && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} Update
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Account
